module.exports = __webpack_public_path__ + "static/img/handshake_1.e68789d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/handshake_1.png
// module id = kba4
// module chunks = 1